import { Sarlaft, SarlaftFilter } from '../shared/types/modules/sarlaft';
import { apiService } from './index';
import { ResponseData } from '../shared/types/shared';

export const asyncGetSarlafts = async (
    filters: SarlaftFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: Sarlaft[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Sarlaft[]; length: number };
        } = await apiService.get('/api/sarlaft', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetSarlaft = async (
    idSarlaft: string
): Promise<Sarlaft | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Sarlaft;
        } = await apiService.get(`/api/sarlaft/${idSarlaft}`);

        return data;
    } catch (error) {}
};

export const asyncCreateSarlaft = async (
    sarlaft: Sarlaft
): Promise<Sarlaft | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Sarlaft;
        } = await apiService.post('/api/sarlaft', sarlaft);

        return data;
    } catch (error) {}
};

export const asyncGetSendCode = async (
    account: string
): Promise<{ sms: ResponseData; email: ResponseData }> => {
    try {
        const {
            items: data,
        }: {
            items: { sms: ResponseData; email: ResponseData };
        } = await apiService.get(`/api/sarlaft/send/${account}`);

        return data || { items: [], length: 0 };
    } catch (error) {
        return { sms: {}, email: {} };
    }
};

export const asyncGetValidateCode = async (
    account: string,
    code: string
): Promise<ResponseData | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ResponseData;
        } = await apiService.get(`/api/sarlaft/validate/${account}/${code}`);

        return data;
    } catch (error) {}
};
export const asyncUpdateSarlaft = async (
    id: string,
    sarlaft: Sarlaft
): Promise<Sarlaft | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Sarlaft;
        } = await apiService.patch(`/api/sarlaft/${id}`, sarlaft);

        return data;
    } catch (error) {}
};

export const asyncGetSendEmail = async (
    account: string,
    unusual: boolean,
    taxReturn: boolean
): Promise<ResponseData | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ResponseData;
        } = await apiService.get(
            `/api/sarlaft/send/unusual/${account}/${unusual}/${taxReturn}`
        );

        return data;
    } catch (error) {}
};
